import React, { useState, useEffect } from "react";
import Vlogo from "../../assets/image/emv.png";
import Rlogo from "../../assets/image/rs.png";
import "./Bottombar.css";

const Bottombar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Toggle visibility every 5 seconds
    const interval = setInterval(() => {
      setIsVisible((prev) => !prev);
    }, 5000); // Adjust time gap here (5000ms = 5 seconds)
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`Bottombar ${isVisible ? "visible" : "hidden"}`}>
      <div className="footer-wave-container">
        <svg
          className="footer-wave"
          viewBox="0 0 1200 120"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0,50 C300,150 900,0 1200,50 L1200,120 L0,120 Z"
            fill="var(--main)" fillOpacity="0.7"
          />
        </svg>
        <svg
          className="footer-wave"
          viewBox="0 0 1200 120"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0,50 C300,200 900,-50 1200,50 L1200,120 L0,120 Z"
            fill="var(--main)" fillOpacity="0.5"
          />
        </svg>
        <svg
          className="footer-wave"
          viewBox="0 0 1200 120"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0,50 C300,200 900,-50 1200,50 L1200,120 L0,120 Z"
            fill="var(--main)" fillOpacity="0.3"
          />
        </svg>
        <footer className="carve-h-footer">
          <div className="footer-comp">
            <div>
              <span>A product of </span>
              <a
                href="https://enminvithaigal.in"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Vlogo} alt="v-logo" />
                <div className="d-flex tiny-chamber">
                  <span style={{ color: "#cc3333", fontSize: "1.3rem" }}>எ</span>
                  <span style={{ color: "#339999", fontSize: "1.3rem" }}>ண்</span>
                  <span style={{ color: "#cc3333", fontSize: "1.3rem" }}>மின்</span>
                  <span style={{ color: "#669900", fontSize: "1.3rem" }}>
                    விதைகள்
                  </span>
                </div>
              </a>
            </div>
            <div>
              <span>
                &nbsp; &nbsp; © 2025 Carve CSS Universe &nbsp; | &nbsp; All
                rights reserved.
              </span>
            </div>
            <div>
              <span> &nbsp; &nbsp; Powered by </span>
              <a href="https://www.rajasri.com/" target="_blank" rel="noreferrer">
                <img src={Rlogo} alt="r-logo" />
                <div className="d-flex tiny-chamber">
                  <span style={{ color: "#dd2725" }}>Ra</span>
                  <span style={{ color: "#339999" }}>ja</span>
                  <span style={{ color: "#dd2725" }}>sri</span>
                  <span style={{ color: "#669900" }}>&nbsp;Systems</span>
                </div>
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Bottombar;
